import { DataGridState } from "@sl/react-datafabric-components";
import { ListResponse } from "../../../redux/BaseReduxService";
import { User } from "../../types/user";
import { convertStateToParams } from "../utils";
import { authApi } from "./auth";
import { mainServiceURL } from "./defines";

export const userApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCurrentUsers: builder.query<{ data: User }, void>({
      query: () => mainServiceURL + `/users/current`,
      providesTags: ["Profile"],
    }),
    fetchUsers: builder.query<ListResponse<User>, DataGridState<Partial<User>>>(
      {
        query: (gridState) => {
          const processedState = convertStateToParams(gridState);
          return {
            url: mainServiceURL + "/users",
            method: "GET",
            params: processedState,
          };
        },
        providesTags: ["Users"],
      }
    ),
  }),
});

export const { useFetchCurrentUsersQuery, useFetchUsersQuery } = userApi;

export function useFetchUserDetail() {
  return useFetchCurrentUsersQuery();
}
